// Cross-repo enum source — keep admin and mobile in sync (manual copy per
// navigationConfig.ts precedent). Canonical values match the DB CHECK
// constraints in supabase/migrations/ and must not drift.
//
// EXPENSE_CATEGORIES intentionally NOT exported here: project_expenses (admin
// job costing) and expenses (CRA-tax tracking) have semantically distinct
// category sets that must stay separate. project-side lives in
// pages/Projects/config.ts; CRA-tax lives in constants/expenseCategories.ts.

// invoices.payment_method CHECK (cash, card, etransfer, cheque, other)
// supabase/migrations/028_invoicing.sql + 050_financials.sql
export const PAYMENT_METHODS = [
  { value: 'cash',      label: 'Cash' },
  { value: 'card',      label: 'Card' },
  { value: 'etransfer', label: 'E-Transfer' },
  { value: 'cheque',    label: 'Cheque' },
  { value: 'other',     label: 'Other' },
] as const;
export type PaymentMethod = typeof PAYMENT_METHODS[number]['value'];

// bookings.source CHECK (app, booking_page, phone, walk_in)
// supabase/migrations/010_vendors_clients_booking.sql:129
export const BOOKING_SOURCES = [
  { value: 'app',          label: 'App' },
  { value: 'booking_page', label: 'Booking Page' },
  { value: 'phone',        label: 'Phone' },
  { value: 'walk_in',      label: 'Walk-In' },
] as const;
export type BookingSource = typeof BOOKING_SOURCES[number]['value'];
